import { WebSocketHelper } from 'classes/helpers/web-socket.helper';
import { WsMsgType } from 'lib_ts/enums/machine-msg.enum';
import { IMachineStateCurrent } from 'lib_ts/interfaces/machine-msg/i-machine-state';
import { IReadyMsg } from 'lib_ts/interfaces/machine-msg/i-ready';
import { useEffect } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import useMachineStatusStore from 'stores/use-machine-status-store';

// listens for r2f msgs and updates the store
const useR2fListener = (): void => {
  const wsConnected = useAuthStore((s) => s.wsConnected);
  const receivedR2f = useMachineStatusStore((s) => !!s.r2fDate);

  useEffect(() => {
    if (!wsConnected) {
      // clear sticky r2f state so MsCurrent fallback can re-bootstrap on reconnect
      useMachineStatusStore.getState().setR2fData(undefined);
      return;
    }

    const r2fCallback = (event: CustomEvent) => {
      const data: IReadyMsg = event.detail;
      useMachineStatusStore.getState().setR2fData(data);
    };

    WebSocketHelper.on(WsMsgType.M2U_ReadyToFire, r2fCallback);

    return () => WebSocketHelper.remove(WsMsgType.M2U_ReadyToFire, r2fCallback);
  }, [wsConnected]);

  // fallback for cases where machine hasn't sent an r2f msg yet
  useEffect(() => {
    if (!wsConnected) {
      return;
    }

    // if we've already received an r2f msg, don't need to listen for ms current
    if (receivedR2f) {
      return;
    }

    const msCurrentCallback = (event: CustomEvent) => {
      const data: IMachineStateCurrent = event.detail;
      useMachineStatusStore.getState().setS2mReady(data.machine_status);
    };

    WebSocketHelper.on(WsMsgType.M2U_MsCurrent, msCurrentCallback);

    return () =>
      WebSocketHelper.remove(WsMsgType.M2U_MsCurrent, msCurrentCallback);
  }, [wsConnected, receivedR2f]);
};

export default useR2fListener;
